<h2 mat-dialog-title *ngIf="isExistingUseLabel">Edit Is Not Calibrated Reason</h2>
<h2 mat-dialog-title *ngIf="!isExistingUseLabel">Create Is Not Calibrated Reason</h2>
<div class="content flex column">
    <mat-form-field class="full-width-field">
        <input matInput placeholder="Type Is Not Calibrated Reason:" [(ngModel)]="currentRecord.Reason"
            (ngModelChange)="checkValidation($event)" maxlength="55">
        <mat-hint *ngIf="validationErrors" class="subscript-error">{{ validationErrors }}</mat-hint>
        <mat-hint *ngIf="!validationErrors">&nbsp;</mat-hint>
    </mat-form-field>

    <mat-slide-toggle [(ngModel)]="currentRecord.IsDefault">Set as Default</mat-slide-toggle>
</div>

<mat-dialog-actions class="flex end">
    <button class="button action" [disabled]="!isValidRecord || isExecuting"
        (click)="updateRecord()">Save</button>
    <button class="button" mat-dialog-close cdkFocusInitial>Cancel</button>
</mat-dialog-actions>
